<app-account-page-wrapper
  title="Confirm your email"
  subtitle="We are verifying your email confirmation link."
>
  <div class="confirm-status confirm-status-{{ status() }}">
    @switch (status()) {
      @case ("loading") {
        <span class="confirm-icon" aria-hidden="true">...</span>
        <h2>Confirming your email</h2>
        <p>Please wait while we verify your account.</p>
      }
      @case ("success") {
        <span class="confirm-icon" aria-hidden="true">✓</span>
        <h2>Email confirmed</h2>
        <p>{{ message() }}</p>
        <p class="confirm-note">Redirecting you to sign in...</p>
        <a class="btn btn-primary btn-block" [routerLink]="[routes.accountLogin.url]">Sign in now</a>
      }
      @case ("error") {
        <span class="confirm-icon" aria-hidden="true">!</span>
        <h2>Confirmation failed</h2>
        <p>{{ message() }}</p>
        <a class="btn btn-primary btn-block" [routerLink]="[routes.accountLogin.url]">Back to sign in</a>
      }
    }
  </div>
</app-account-page-wrapper>
